export const toEasternDateKey = (dateValue) => new Date(dateValue).toLocaleDateString('en-US', {
  timeZone: 'America/New_York',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

export const getEasternTodayKey = () => toEasternDateKey(new Date());

export const formatEasternDayLabel = (dateKey) => {
  const todayKey = getEasternTodayKey();
  const yesterdayKey = toEasternDateKey(new Date(Date.now() - 86400000));
  if (dateKey === todayKey) return 'Today';
  if (dateKey === yesterdayKey) return 'Yesterday';
  if (dateKey === 'Unknown') return 'Date unavailable';
  const [month, day, year] = dateKey.split('/');
  return new Date(Number(year), Number(month) - 1, Number(day)).toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
};